import { createContext, useContext } from 'react';

export type OpenProjectDetailsFn = (anchorEl: HTMLElement | null) => void;

export const ProjectRowProjectDetailsContext = createContext<OpenProjectDetailsFn | null>(null);

export function useProjectRowOpenDetails(): OpenProjectDetailsFn | null {
  return useContext(ProjectRowProjectDetailsContext);
}
